interface BulletListProps {
  items: string[];
}

const BulletList = ({ items }: BulletListProps) => {
  return (
    <ul className="space-y-3 mb-8 ml-6">
      {items.map((item, index) => (
        <li key={index} className="text-gray-300 leading-relaxed list-disc">
          {item.replace('-', '').trim()}
        </li>
      ))}
    </ul>
  );
};

export default BulletList;